import { InvoicePaymentStatuses } from '../../apis/graphql/types';
import { Option } from '../../components/types';
import { StatusColor } from './statusColor';

const DisplayedInvoicePaymentStatuses = {
  Paid: 'Paid',
  Unpaid: 'Unpaid',
  Overdue: 'Overdue',
  Voided: 'Voided',
} as const;

export const invoiceStatusColors = {
  [DisplayedInvoicePaymentStatuses.Paid]: StatusColor.GREEN,
  [DisplayedInvoicePaymentStatuses.Unpaid]: StatusColor.RED,
  [DisplayedInvoicePaymentStatuses.Voided]: StatusColor.GRAY,
  [DisplayedInvoicePaymentStatuses.Overdue]: StatusColor.RED,
};

export const invoiceStatusToDisplayMap = {
  [InvoicePaymentStatuses.Pending]: DisplayedInvoicePaymentStatuses.Unpaid,
  [InvoicePaymentStatuses.Processing]: DisplayedInvoicePaymentStatuses.Unpaid,
  [InvoicePaymentStatuses.Failed]: DisplayedInvoicePaymentStatuses.Unpaid,
  [InvoicePaymentStatuses.Success]: DisplayedInvoicePaymentStatuses.Paid,
  [InvoicePaymentStatuses.Hold]: DisplayedInvoicePaymentStatuses.Unpaid,
  [InvoicePaymentStatuses.Void]: DisplayedInvoicePaymentStatuses.Voided,
  [InvoicePaymentStatuses.Paused]: DisplayedInvoicePaymentStatuses.Unpaid,
  [InvoicePaymentStatuses.PartiallyFailed]: DisplayedInvoicePaymentStatuses.Unpaid,
  [InvoicePaymentStatuses.RevisedPending]: DisplayedInvoicePaymentStatuses.Unpaid,
  [InvoicePaymentStatuses.PartialPayment]: DisplayedInvoicePaymentStatuses.Unpaid,
  [InvoicePaymentStatuses.Overdue]: DisplayedInvoicePaymentStatuses.Overdue,
  [InvoicePaymentStatuses.RefundFailed]: DisplayedInvoicePaymentStatuses.Paid,
};

export const invoiceStatusToInternalMap = new Array<Option<Array<InvoicePaymentStatuses>>>();
invoiceStatusToInternalMap.push({
  label: DisplayedInvoicePaymentStatuses.Paid,
  value: [InvoicePaymentStatuses.Success, InvoicePaymentStatuses.RefundFailed],
});
invoiceStatusToInternalMap.push({
  label: DisplayedInvoicePaymentStatuses.Unpaid,
  value: [
    InvoicePaymentStatuses.Pending,
    InvoicePaymentStatuses.Processing,
    InvoicePaymentStatuses.Failed,
    InvoicePaymentStatuses.Hold,
    InvoicePaymentStatuses.Paused,
    InvoicePaymentStatuses.PartiallyFailed,
    InvoicePaymentStatuses.RevisedPending,
    InvoicePaymentStatuses.PartialPayment,
  ],
});
invoiceStatusToInternalMap.push({
  label: DisplayedInvoicePaymentStatuses.Voided,
  value: [InvoicePaymentStatuses.Void],
});
invoiceStatusToInternalMap.push({
  label: DisplayedInvoicePaymentStatuses.Overdue,
  value: [InvoicePaymentStatuses.Overdue],
});
